import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-projeto-relatorio',
  templateUrl: './projeto-relatorio.component.html',
  styleUrls: ['./projeto-relatorio.component.scss']
})
export class ProjetoRelatorioComponent implements OnInit {
  filter_question: number = 0;
  filter_agency: number[] = [];
  report_1_param_1: number = 0;
  report_3_param_1: number = 0;
  report_type: number = 1;

  constructor(
		public acRoute: ActivatedRoute,
  ) { }

  ngOnInit() {
    this.acRoute.queryParams.subscribe(params => {
			if (params) {
				this.filter_question = params['filter_question'] ?? [];
				this.report_1_param_1 = params['report_1_param_1'] ?? 0;
				this.report_3_param_1 = params['report_3_param_1'] ?? 0;
				this.report_type = params['report_type'] ?? 0;
        this.filter_agency = params['filter_agency[]'] ?? [];
			}
		});
  }

}
